import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("isAuthenticated"); // removes the item
    // Redirect to login
    navigate("/login", { replace: true });
  }, [navigate]);

  return null; // No UI needed
};

export default Logout;
